import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { FeatureName } from './FeatureName';

export class FeatureFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [FeatureName];
  }

  get title() {
    return terminology('Feature');
  }
}
